<template>
  <div class="authorize-list page-box">
    <query-header
      ref="header"
      :selected="selected"
      :product-list="productList"
      @toQuery="searchHandle"
      @add="addHandle"
      @delete="deleteHandle"
      @upload="uploadHandle"
      @export="exportHandle"
    ></query-header>
    <div class="page-content">
      <div class="vs-table-outer">
        <vs-table
          multiple
          v-model="selected"
          :data="listData"
        >
          <template
            slot="thead">
            <vs-th>
              ID
            </vs-th>
            <vs-th>
              客户姓名
            </vs-th>
            <vs-th>
              手机
            </vs-th>
            <vs-th>
              授权产品
            </vs-th>
            <vs-th>
              类型
            </vs-th>
            <vs-th>
              授权码
            </vs-th>
            <vs-th>
              有效期
            </vs-th>
            <vs-th>
              授权状态
            </vs-th>
            <vs-th>
              平台
            </vs-th>
            <vs-th>
              Login
            </vs-th>
            <vs-th>
              Mac
            </vs-th>
            <vs-th>
              推荐人
            </vs-th>
            <vs-th>
              操作
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr
              v-for="(tr, index) in data"
              :key="index"
              :data="tr"
            >
              <vs-td>
                {{tr.id}}
              </vs-td>
              <vs-td>
                {{tr.userName}}
              </vs-td>
              <vs-td>
                {{tr.phone}}
              </vs-td>
              <vs-td
                width="150"
              >
                <el-popover
                  v-if="getOverFlow(tr)"
                  placement="top-start"
                  title="全部授权产品"
                  width="200"
                  trigger="hover"
                  :content="getContent(tr)">
                  <product-inner
                    slot="reference"
                    v-if="getOverFlow(tr)"
                    :product-list="productList"
                    :str-list="tr.authorizedProducts"
                  ></product-inner>
                </el-popover>
                <product-inner
                  v-if="!getOverFlow(tr)"
                  :product-list="productList"
                  :str-list="tr.authorizedProducts"
                ></product-inner>
              </vs-td>
              <vs-td>
                {{ getAuthType(tr)}}
              </vs-td>

              <vs-td
                style="max-width: 150px;"
              >
                <span
                  class="rap-normal"
                >{{tr.authorizationCode}}</span>
              </vs-td>
              <vs-td>
                <div>{{tr.beginDate}}</div>
                <div>{{tr.endDate}}</div>
              </vs-td>
              <vs-td
                style="min-width: 180px;"
              >
                <span
                  class="self-tag"
                  :style="getStyle(tr)"
                >{{getStatus(tr)}}</span>
              </vs-td>
              <vs-td>
                {{tr.bindPlatform || '-'}}
              </vs-td>
              <vs-td>
                {{tr.bindLogin || '-'}}
              </vs-td>
              <vs-td>
                {{tr.bindMac || '-'}}
              </vs-td>
              <vs-td>
                {{tr.referrer || '-'}}
              </vs-td>
              <vs-td>
                <el-button
                  type="text"
                  v-if="isAuth('auth:management:update')"
                  class="pointer"
                  @click.stop="editHandle(tr)"
                >修改</el-button>
<!--                <el-button
                  type="text"
                  v-if="isAuth('auth:management:update')"
                  class="pointer delete-btn"
                  @click="deleteHandle(tr)"
                >删除</el-button>-->
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">合计 {{total}} 条</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
    <add-dialog
      :product-list="productList"
      :dialog-show="addDialogShow"
      @close="closeAddDialog"
      @add-success="addUserSuccess"
    ></add-dialog>
    <edit-dialog
      :product-list="productList"
      :row-data="currentRow"
      :dialog-show="editDialogShow"
      @close="closeEditDialog"
      @edit-success="editUserSuccess"
    ></edit-dialog>
    <multiple-delete-dialog
      ref="muldelete"
      :ids="ids"
      @sure-delete="confirmDelete"
    ></multiple-delete-dialog>
    <import-dialog
      :dialog-show="importShow"
      @close="importShow = false"
      @success="importSuccessHandle"
    ></import-dialog>
  </div>
</template>

<script>
import { export_json_to_excel,formatJson } from '@/vendor/Export2Excel'
import importDialog from "@/components/authorize/importDialog";
import multipleDeleteDialog from "@/components/public/multipleDeleteDialog";
import editDialog from '@/components/authorize/editDialog'
import addDialog from "@/components/authorize/addDialog";
import queryHeader from "@/components/authorize/queryHeader";
import { mapGetters } from 'vuex'
import { colorRgba,parseTime } from '@/utils/index'
import productInner from "@/components/authorize/productInner";
import initData from "@/mixins/initData";
import { deleteUser } from "@/api/sys/userList";
export default {
  name: "index",
  components: {
    addDialog,
    editDialog,
    queryHeader,
    multipleDeleteDialog,
    productInner,
    importDialog,
  },
  data() {
    return {
      selected: [],
      productList: [],
      red: '#D85E5F',
      green: '#41B883',
      addDialogShow: false,
      editDialogShow: false,
      currentRow: {},
      max:8,
      ids: [],
      importShow: false,
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['themeColor','userInfo']),
  },
  created(){
    this.getProducts();
  },
  mounted(){
    this.init();
  },
  methods: {
    parseTime,
    beforeInit(){
      this.url = '/wx/manage/authorization/list';
      this.params = {
        page: this.page,
        limit: this.size,
        'sidx': 'id',
        'order': 'desc'
      }
      let header = this.$refs.header;
      if(header.status !== ''){
        this.params.status = header.status;
      }
      if(header.productType){
        this.params.productCode = header.productType;
      }
      if(header.customerInfo){
        this.params.userInfo = header.customerInfo;
      }
      if(header.recommenInfo){
        this.params.referrer = header.recommenInfo;
      }
      if(header.type){
        this.params.type = header.type;
      }
      return true;
    },

    getProducts(){
      this.$http({
        url: '/wx/authorizedProduct/all',
        method: 'get',
      }).then((data) => {
        if (data && data.code === 200) {
          this.productList = data.data;
        } else {
          this.dataList = []
        }
      })
    },
    getContent(row){
      let handlerArr = row.authorizedProducts.split(',');
      let textArr = [];
      for (let i = 0; i < this.productList.length; i++) {
        if(handlerArr.indexOf(this.productList[i].productCode) > - 1){
          textArr.push(this.productList[i].productName + `(${i+1})`);
        }
      }
      return textArr.join(';');
    },
    getOverFlow(row){
      if(row.authorizedProducts.split(',').length > 3){
        return true;
      }else {
        return false;
      }
    },
    getStatus(row){
      switch (row.status){
        case 1:
          return `有效 (剩余${row.remainingDays}天)`;
        case 0:
          return '失效';
      }
    },
    getAuthType(row){
      switch (row.type){
        case 1:
          return '普通码';
        case 2:
          return '试用码';
      }
    },
    getStyle(tr){
      if(tr.status === 0){
        return {
          backgroundColor: colorRgba(this.red ,0.1),
          color: this.red,
        };
      }else {

        return {
          backgroundColor: colorRgba(this.green,0.1),
          color: this.green,
        };
      }
    },
    addHandle(){
      setTimeout(() => {
        this.addDialogShow = true;
      },200);
    },
    addUserSuccess(){
      this.addDialogShow = false;
      this.searchHandle();
    },
    // 上传表格 todo
    uploadHandle(){
      this.importShow = true;
    },
    importSuccessHandle(){
      this.importShow = false;
      this.searchHandle();
    },
    editHandle(row){
      this.currentRow = row;
      setTimeout(() => {
        this.editDialogShow = true;
      },200);
    },
    editUserSuccess(){
      this.currentRow = {}
      this.editDialogShow = false;
      this.searchHandle();
    },
    closeEditDialog(){
      this.currentRow = {}
      this.editDialogShow = false;
    },
    deleteHandle(row){
      this.ids = row ? [row.id] : this.selected.map(item => item.id);
      this.$refs.muldelete.dialogShow = true;
    },
    confirmDelete(ids){
      deleteUser(ids).then((res) => {
        this.$message({
          type: 'success',
          message: '已删除'
        });
        this.searchHandle();
      })
    },
    closeAddDialog(){
      this.addDialogShow = false;
    },
    exportHandle(){
      if(this.selected.length == 0){
        this.$message({
          type: 'warning',
          message: '请勾选'
        });
        return;
      }
      for (let i = 0; i < this.selected.length; i++) {
        this.selected[i].handlerStatus = this.getStatus(this.selected[i]);
      }
      const tHeader =['ID','客户姓名','手机','授权产品','授权码','开始日期', '结束日期','状态','平台','Login','推荐人'];
      const filterVal =['id','userName','phone','productNames','authorizationCode','beginDate','endDate','handlerStatus','bindPlatform','bindLogin','referrer'];
      const exportData = formatJson(filterVal,this.selected);
      let fileName='授权管理';
      export_json_to_excel(tHeader,exportData,fileName);
    },
    searchHandle(){
      this.page = 1;
      this.init();
    },
  },
}
</script>

<style lang="scss" scoped>
.authorize-list {
  .box-item {
    margin-bottom: 10px;
  }
  .btn {
    margin-right: 10px;
  }
  .vs-table-outer {
    .vs-con-table {
    }
  }
  .tag-box {
    padding: 5px 10px;
    border-radius: 15px;
  }
  .reject-reason {
    max-width: 120px;
  }
}
</style>
